/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListSystemSettingsResponseDto,
  SystemSettingHistoryResponseDto,
  SystemSettingResponseDto,
  UpdateSystemSettingRequestDto,
} from '../models/index';
import {
    ListSystemSettingsResponseDtoFromJSON,
    ListSystemSettingsResponseDtoToJSON,
    SystemSettingHistoryResponseDtoFromJSON,
    SystemSettingHistoryResponseDtoToJSON,
    SystemSettingResponseDtoFromJSON,
    SystemSettingResponseDtoToJSON,
    UpdateSystemSettingRequestDtoFromJSON,
    UpdateSystemSettingRequestDtoToJSON,
} from '../models/index';

export interface SystemSettingsControllerGetRequest {
    key: string;
}

export interface SystemSettingsControllerHistoryRequest {
    key: string;
    limit?: number;
    page?: number;
}

export interface SystemSettingsControllerUpdateRequest {
    key: string;
    updateSystemSettingRequestDto: UpdateSystemSettingRequestDto;
}

/**
 * 
 */
export class PlatformSystemSettingsApi extends runtime.BaseAPI {

    /**
     */
    async systemSettingsControllerGetRaw(requestParameters: SystemSettingsControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingResponseDto>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling systemSettingsControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-settings/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemSettingResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemSettingsControllerGet(requestParameters: SystemSettingsControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingResponseDto> {
        const response = await this.systemSettingsControllerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async systemSettingsControllerHistoryRaw(requestParameters: SystemSettingsControllerHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingHistoryResponseDto>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling systemSettingsControllerHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-settings/{key}/history`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemSettingHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemSettingsControllerHistory(requestParameters: SystemSettingsControllerHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingHistoryResponseDto> {
        const response = await this.systemSettingsControllerHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async systemSettingsControllerListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSystemSettingsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSystemSettingsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemSettingsControllerList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSystemSettingsResponseDto> {
        const response = await this.systemSettingsControllerListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async systemSettingsControllerUpdateRaw(requestParameters: SystemSettingsControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingResponseDto>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling systemSettingsControllerUpdate().'
            );
        }

        if (requestParameters['updateSystemSettingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateSystemSettingRequestDto',
                'Required parameter "updateSystemSettingRequestDto" was null or undefined when calling systemSettingsControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-settings/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSystemSettingRequestDtoToJSON(requestParameters['updateSystemSettingRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemSettingResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemSettingsControllerUpdate(requestParameters: SystemSettingsControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingResponseDto> {
        const response = await this.systemSettingsControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
